"use client";
import { useState, useId } from "react";
import PropTypes from "prop-types";

import PeopleSvg from "assets/svg/people.svg";
import GreenCheck from "assets/svg/green-check-circle.svg";

import { sendMessageHelperTexts } from "constants/modal-send-message";

import { sendMessage } from "services/message";

import { createImageUrl } from "helpers/create-image-url";
import { getUserInfo, getToken } from "helpers/auth";
import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import Button from "components/common/button";
import TextArea from "components/common/textarea";
import { LazyImage } from "components/common/lazy-image/LazyImage";

import styles from "./styles.module.css";

const ModalSendMessage = ({ data }) => {
  const keyId = useId();

  const {
    owner: { member, account },
    title,
    id,
  } = data;

  const [value, setValue] = useState("");
  const [handledHelperIndex, setHandledHelperIndex] = useState([]);
  const [messagedSentResponse, setMessagedSentResponse] = useState(null);
  const handleChange = (e) => {
    if (e.target.value.length === 0) setHandledHelperIndex([]);
    setValue(e.target.value);
  };

  const handleHelperText = (text, index) => {
    if (handledHelperIndex.indexOf(index) >= 0) return;
    setValue(`${value} ${text}`);
    setHandledHelperIndex([...handledHelperIndex, index]);
  };

  const handleSend = async () => {
    try {
      await sendMessage({
        senderFullname: getUserInfo("fullName") || "",
        senderMailAddress: getUserInfo("emailAddress") || "",
        senderMobilePhone: getUserInfo("mobilePhone") || null,
        senderMemberId: getUserInfo("id") || "",
        message: value,
        channel: "DESKTOP_WEB",
        reason: "LISTING_DETAIL",
        title,
        relatedId: id,
        receiverMemberId: member?.id,
        receiverFullname: member?.name,
        allowCommunication: false,
        allowInfoShare: false,
        membershipContractApproved: true,
      }).then((response) => {
        if (response.status === "success") {
          setMessagedSentResponse(response.result);
          Ga4WithEventParameters({
            eventName: "send_message",
            eventParameters: {
              item_id: id.toString(),
              item_type: "ilan",
            },
          });
        }
      });
    } catch (error) {
      console.error(`Error! Send message action has a problem: ${error}`);
    }
  };

  return (
    <>
      {messagedSentResponse ? (
        <div className={styles.resultWrap}>
          <span className={styles.resultIcon}>
            <GreenCheck />
          </span>
          <h2 className={styles.resultTitle}>Mesajınız Gönderildi!</h2>
          {messagedSentResponse.firstMessage ? (
            <p className={styles.resultContent}>İlan sahibi size en kısa sürede ulaşacaktır.</p>
          ) : (
            <>
              <p className={styles.resultContent}>
                İlan sahibiyle mesajlaşma geçmişini mesajlarım sayfasından görebilirsin.
              </p>
              <div className={styles.resultAction}>
                <Button
                  href={`${
                    window.env.EJ_APPS_PANEL_HOSTNAME
                  }/#/member/authorize?token=${getToken()}&redirectUrl=mesajlarim`}
                  size="M"
                >
                  Mesajlarıma Git
                </Button>
              </div>
            </>
          )}
        </div>
      ) : (
        <div className={styles.wrapper}>
          <h2 className={styles.title}>İlan Sahibine Mesaj Gönder</h2>
          <div className={styles.inner}>
            <div className={styles.userInfoWrap}>
              <div className={styles.logo}>
                {account?.logo ? (
                  <LazyImage
                    src={createImageUrl(account.logo, {
                      width: 57,
                      height: 51,
                    })}
                  />
                ) : (
                  <PeopleSvg />
                )}
              </div>
              <div className={styles.userInfo}>
                <h1 className={styles.username}>{member?.name}</h1>
                <h2 className={styles.company}>{account?.name}</h2>
              </div>
            </div>
            <div className={styles.messageBoxWrap}>
              <TextArea rowNumber={6} value={value} onChange={handleChange} placeholder="Mesajınızı yazın..." />
            </div>
            <ul className={styles.helperContentWrap}>
              {sendMessageHelperTexts.map((item, index) => (
                <li key={`${keyId}-${index}`} onClick={() => handleHelperText(item, index)}>
                  {item}
                </li>
              ))}
            </ul>
            <div className={styles.actionWrap}>
              <Button disable={value.length === 0} size="M" onClick={handleSend}>
                Gönder
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

ModalSendMessage.propTypes = {
  data: PropTypes.object,
};

export default ModalSendMessage;
